import { makeStyles } from "@material-ui/core";

export default makeStyles((theme)=>({
    primary:{
        textAlign: "center",
        backgroundColor: theme.palette.primary.main,
        borderRadius:"50px",
        width:"70%",
        color: "white",
        fontWeight: "900",
        fontFamily: "Montserrat",
        margin: theme.spacing(3),
        padding: theme.spacing(1),
        '&:hover':{
            backgroundColor: theme.palette.secondary.main,
        }
    },
}))

